export default __webpack_public_path__ + "static/media/education1.e0a318d7.jpg";